"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backend = void 0;
const app_backend_api_1 = require("@vue-devtools/app-backend-api");
exports.backend = (0, app_backend_api_1.defineBackend)({
    frameworkVersion: 1,
    features: [],
    setup(api) {
        // @TODO
    },
});
//# sourceMappingURL=index.js.map